var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersThree01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1944_59289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 9.99997L9.70194 14.0176C9.81126 14.0722 9.86592 14.0996 9.92325 14.1103C9.97403 14.1198 10.0261 14.1198 10.0769 14.1103C10.1342 14.0996 10.1889 14.0722 10.2982 14.0176L18.3334 9.99997M1.66675 14.1666L9.70194 18.1842C9.81126 18.2389 9.86592 18.2662 9.92325 18.277C9.97403 18.2865 10.0261 18.2865 10.0769 18.277C10.1342 18.2662 10.1889 18.2389 10.2982 18.1842L18.3334 14.1666M1.66675 5.83331L9.70194 1.81571C9.81126 1.76105 9.86592 1.73372 9.92325 1.72297C9.97403 1.71344 10.0261 1.71344 10.0769 1.72297C10.1342 1.73372 10.1889 1.76105 10.2982 1.81571L18.3334 5.83331L10.2982 9.8509C10.1889 9.90556 10.1342 9.93289 10.0769 9.94365C10.0261 9.95317 9.97403 9.95317 9.92325 9.94365C9.86592 9.93289 9.81126 9.90556 9.70194 9.8509L1.66675 5.83331Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1944_59289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersThree01);
export default __webpack_public_path__ + "static/media/layers-three-01.2f68fb43ef7a219826ad7238c591436c.svg";
export { ForwardRef as ReactComponent };